export default "__VITE_ASSET__BQ5J0Fzj__"